import React, { useEffect, useRef } from 'react';
import CustomBeforeAfterSlider from '../components/CustomBeforeAfterSlider';
import './Page1.css';

import bg_gotas_big from './../assets/page1/bg_gotas_big.png';
import bg_gotas_small from './../assets/page1/bg_gotas_small.png';

function Page1() {
  const inactivityTimeoutRef = useRef(null);
  const [anyInputReceived, setAnyInputReceived] = React.useState(false);

  const resetInactivityTimeout = () => {
    if (inactivityTimeoutRef.current) {
      clearTimeout(inactivityTimeoutRef.current);
    }
    inactivityTimeoutRef.current = setTimeout(() => {
      if(!anyInputReceived){
        window.location.reload();
      }
    }, 30000);
  };

  useEffect(() => {
    resetInactivityTimeout();
    const handleActivity = () => {resetInactivityTimeout(); setAnyInputReceived(true);};

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('touchstart', handleActivity);

    return () => {
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
    };
  }, []);

  return (
    <div className="page1-container">
      <CustomBeforeAfterSlider firstImage={bg_gotas_big} secondImage={bg_gotas_small} />
    </div>
  );
}

export default Page1;
